import { render, staticRenderFns } from "./diy-area-select.vue?vue&type=template&id=70ea2d99&scoped=true"
import script from "./diy-area-select.vue?vue&type=script&lang=js"
export * from "./diy-area-select.vue?vue&type=script&lang=js"
import style0 from "./diy-area-select.vue?vue&type=style&index=0&id=70ea2d99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea2d99",
  null
  
)

export default component.exports